import * as yup from "yup";
import { getEmailsValidationSchema } from "@/components/common/integration-dialogs/components/email/utils/validation";
import { integrationNotificationValidationSchema } from "@/components/pages/common/notification-selection/utils/validation/validation";
import { Emails } from "@/services/cloudchipr.api";

export const validationSchema = yup.object({
  name: yup.string().required("This field is required."),
  viewId: yup.string().when("basedOn", {
    is: "viewId",
    then: yup.string().required("ViewId is required."),
    otherwise: yup.string().nullable(),
  }),
  filter_tree: yup.mixed().when("basedOn", {
    is: "filterTree",
    then: yup
      .mixed()
      .required("Filter Tree is required.")
      .test(
        "is-not-empty-array",
        "Filter Tree should not be empty",
        (value) => {
          if (!value) return false;
          if (value.node_type === "group" && Array.isArray(value.items)) {
            return value.items.length > 0;
          }
          return true;
        },
      ),
    otherwise: yup.mixed().nullable(),
  }),
  period: yup.string().required("This field is required."),
  startDate: yup.string().required("This field is required."),
  endDate: yup
    .string()
    .nullable()
    .when(["noEndDate", "period"], {
      is: (noEndDate: boolean, period: string) =>
        !noEndDate && period === "custom",
      then: yup.string().required("This field is required."),
      otherwise: yup.string().nullable(),
    }),
  amount: yup.number().when("type", {
    is: (type: string) => type === "fixed",
    then: yup
      .number()
      .min(1, "Minimum value is 1")
      .max(
        Number.MAX_SAFE_INTEGER,
        `Maximum value is ${Number.MAX_SAFE_INTEGER}`,
      )
      .required(""),
    otherwise: yup.number().nullable(),
  }),
  planned_amounts: yup
    .array()
    .nullable()
    .when("type", {
      is: "planned",
      then: yup
        .array()
        .of(
          yup
            .number()
            .required("This field is required")
            .min(1, "Minimum value is 1")
            .max(
              Number.MAX_SAFE_INTEGER,
              `Maximum value is ${Number.MAX_SAFE_INTEGER}`,
            ),
        ),
      otherwise: yup.array().nullable(),
    }),
  thresholds: yup
    .array()
    .of(
      yup.object({
        percent: yup
          .number()
          .min(1, "This field is required.")
          .required("This field is required."),
      }),
    )
    .min(1, "At least one threshold should be selected."),

  email_to: getEmailsValidationSchema(true),

  notifications: yup
    .array()
    .nullable()
    .when("email_to", {
      is: (email_to: Emails | null) => !!email_to,
      then: yup.array().of(integrationNotificationValidationSchema).nullable(),
      otherwise: yup
        .array()
        .of(integrationNotificationValidationSchema)
        .min(1, "At least one integration should be selected."),
    }),
});
